import { gql } from '@apollo/client';
import TaxEvidenceInfo from './TaxEvidenceInfo';

const CustomerTaxExemptionInfo = gql`
  fragment CustomerTaxExemptionInfo on CustomerTaxExemption {
    id
    accountId
    certificateNumber
    effectiveAt
    exemptionType
    expiresAt
    issuedOn
    jurisdictions
    resolutionReason
    state
    verifiedAt
    verifiedById
    taxEvidence {
      ...TaxEvidenceInfo
    }
  }
  ${TaxEvidenceInfo}
`;

export default CustomerTaxExemptionInfo;
